import React from 'react';
import Hero from './HeroArea';
import About from './AboutArea';
import Service from './ServiceArea';
import ChooseUs from './ChooseUsArea';
import Newsletter from '../../components/Newsletter';
import Team from './TeamArea';
import Contact from './ContactArea';
import Blog from './BlogArea';

const HomeMain = () => {
  return (
    <main>
      <Hero />
      <About />
      <Service />
      <ChooseUs />
      <Newsletter />
      <Team />
      <Contact />
      <Blog />
    </main>
  );
};

export default HomeMain;
